export default {
  allAdditionalUsers: [],
  additionalUser: {},
}
